/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input, OnInit} from '@angular/core';
import * as _ from "lodash";
import {interpolateWarning} from "../error/interpolate-warnings-filter";

@Component({
  standalone: false,
  selector: 'info-icon',
  template: `
    <ng-template #popTemplate>
      <div [innerHtml]='text'></div>
    </ng-template>
    <button type="button" class="infoIconLink btn btn-link {{class}} btn-icon-only" [outsideClick]="true" placement="{{placement}}" [popover]="popTemplate"><span class="fa fa-fw fa-info-circle"></span></button>`
})
export class InfoIconComponent implements OnInit {
  @Input() text: any;
  @Input() arrayText: Array<string>;
  @Input() placement = "top";
  @Input() class: string;

  constructor() {
  }

  ngOnInit(): void {
    if (this.arrayText && this.arrayText.length > 0) {
      this.text = "<ul>";
      _.forEach(this.arrayText, (warning) => {
        this.text += "<li>" + interpolateWarning(warning) + "</li>";
      });
      this.text += "</ul>";
    }
  }
}
